<template>
    <PullContainer
        ref="pullContainerRef"
        :pullDownLoading="true"
        :pullDownLabel="true"
        @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container personnel_list_wrap" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
                    <div class="returnNavBarRight">
                        <van-popover
                            v-model="showOperatorPopover"
                            placement="bottom-end"
                            trigger="click"
                            ref="top_operator_popover"
                            class="top_operator_popover"
                        >
                            <div class="top_operator_list">
                                <li v-for="item in operatorList" :key="item.type" @click="handleClickOperate(item)">
                                    <i :class="['iconfont', item.icon]"></i><span>{{ item.title }}</span>
                                </li>
                            </div>
                            <template #reference>
                                <i class="iconfont icon-a-tianjiamiaobian"></i>
                            </template>
                        </van-popover>
                    </div>
                </div>
                <div class="top_search">
                    <van-search
                        v-model="searchForm.keyword"
                        placeholder="请输入查询内容"
                        @search="onSearch"
                        @clear="onSearch"
                    >
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="list_content_title">
                    <span>{{ searchForm.department_name }}（{{ pagination.total }}）</span>
                    <div class="list_content_title_right" v-if="isCheck">
                        <span>{{ isCheckAll ? "全选" : `共${selectedList.length}条` }}</span>
                        <i class="custom_checkbox" :class="{ active: isCheckAll }" @click="handleClickCheckAll"></i>
                    </div>
                </div>
                <div class="mobile_container">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="(item, index) in tableData" :key="index" @click.stop="handleClickDetail(item)">
                            <div class="img_box">
                                <img :src="item.avatar ? item.avatar : defaultImg" alt="" />
                            </div>
                            <div class="list_item_middle">
                                <p>
                                    <span class="ellipsis">{{ item.name && item.name.value }}</span>
                                    <template>
                                        <span
                                            class="tag_status tag_status_danger"
                                            v-if="item.quit_info && item.quit_info.quit_status == 0"
                                            >待离职</span
                                        >
                                        <span class="tag_status tag_status_warning" v-if="item.entry_status == 1"
                                            >待入职</span
                                        >
                                        <span
                                            class="tag_status tag_status_success"
                                            v-if="item.status == 'pendingConfirm'"
                                            >待确定</span
                                        >
                                        <span
                                            class="tag_status tag_status_warning2"
                                            v-if="item.is_active == 0 && item.entry_status == 0"
                                            >未注册</span
                                        >
                                    </template>
                                </p>
                                <p>
                                    <template v-if="item.department_id">
                                        {{
                                            item.department_id.text && item.department_id.text.length
                                                ? item.department_id.text
                                                      .map((department) => department.department_name)
                                                      .join("、")
                                                : "--"
                                        }}
                                    </template>
                                    <template v-else>--</template>
                                </p>
                            </div>
                            <div class="list_item_right" v-if="isCheck" @dblclick.stop.prevent @click.stop.prevent>
                                <van-checkbox
                                    v-model="item.checked"
                                    shape="square"
                                    @change="handleClickChangeSelect(item)"
                                ></van-checkbox>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="batch_select_icon" v-if="isCheck" @click="handleClickShowUser">
                    <i class="iconfont icon-renyuan"></i
                    ><span v-if="selectedList.length">{{ selectedList.length }}</span>
                </div>
                <SelectUserList
                    :selectUserListVisible.sync="selectUserListVisible"
                    :selectUserListData.sync="selectedList"
                    @changeItemSelete="changeItemSelete"
                />
                <BatchOperateBar
                    :operateBarList="operateBarList"
                    @handleClickOperateType="handleClickOperateType"
                    v-if="isCheck"
                />
                <ListAdvancedFiltering
                    v-if="searchPopupShow"
                    ref="listAdvancedFiltering"
                    :field_form="'users'"
                    :system_fields="systemFilterFields"
                    @sendFilterData="getFilterData"
                />
            </div>
        </template>
    </PullContainer>
</template>

<script>
import { mapState } from "vuex";
import { pagination } from "@/mixins";
import { Dialog } from "vant";
import { getUserListPage } from "@/api";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import BatchOperateBar from "../component/batch_operate_bar.vue";
import SelectUserList from "../component/select_user_list.vue";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";

export default {
    name: "MPersonnelList",
    components: { PullContainer, ReturnNavBar, SelectUserList, BatchOperateBar, ListAdvancedFiltering },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            showOperatorPopover: false,
            operatorList: [
                { icon: "icon-a-shenling1", title: "新增员工", type: "add" },
                { icon: "icon-a-shenling1", title: "邀请加入", type: "invit" },
                { icon: "icon-fenpei", title: "批量操作", type: "batch" },
            ],
            searchForm: {
                keyword: "",
                department_id: "",
                department_name: "",
            },
            tableData: [],
            isCheckAll: false, // 是否全选
            isCheck: false, // 是否批量选择
            selectedList: [], // 复选框选中数据
            operateBarList: [
                { icon: "icon-fenpei", title: "变更部门", type: "changeDepartment" },
                { icon: "icon-hebingkehu", title: "邀请完善信息", type: "invit" },
            ],
            selectUserListVisible: false, // 选择的用户数据
            systemFilterFields: [
                {
                    field_type: "radio",
                    field_key: "u.gender",
                    is_system: 1,
                    field_name: "性别",
                    system_type: "system",
                    options: [
                        {
                            label: "男",
                            value: 1,
                        },
                        {
                            label: "女",
                            value: 2,
                        },
                    ],
                },
                {
                    field_type: "date",
                    field_key: "u.joined_date",
                    is_system: 1,
                    field_name: "入职日期",
                    system_type: "system",
                    date_type: "date",
                },
                {
                    field_type: "checkbox_user_tag",
                    field_key: "utr.user_tag_id",
                    is_system: 1,
                    field_name: "人员标签",
                    system_type: "system",
                    options: [],
                },
                {
                    field_type: "contact",
                    field_key: "u.superior_id",
                    is_system: 1,
                    field_name: "直属上级",
                    system_type: "system",
                },
                {
                    field_type: "department",
                    field_key: "u.department_id",
                    is_system: 0,
                    field_name: "部门",
                    system_type: "system",
                },
            ], // 高级筛选字段
            custom_filter: {}, // 高级筛选确认条件
        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["searchPopupShow"]),
    },
    created() {
        if (this.$route.query) {
            this.searchForm.department_id = this.$route.query.id;
            this.searchForm.department_name = this.$route.query.name;
        }
        this.getLocalStorageFunction();
    },
    methods: {
        // 读取缓存
        getLocalStorageFunction() {
            let localStorageData = localStorage.getItem("mobilePersonnelListParams");
            if (localStorageData) {
                localStorageData = JSON.parse(localStorageData);
                this.searchForm.keyword = localStorageData.keyword;
                this.custom_filter = localStorageData.custom_filter;
            }
            this.$nextTick(() => {
                this.onPullRefreshList();
            });
            localStorage.removeItem("mobilePersonnelListParams");
        },
        // 写入缓存
        setLocalStorageFunction() {
            const params = {
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter,
            };
            localStorage.setItem("mobilePersonnelListParams", JSON.stringify(params));
        },
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onPullRefreshList();
            }
        },
        onSearch() {
            this.onPullRefreshList();
        },
        handleClickOperate({ type }) {
            this.setLocalStorageFunction();
            this.showOperatorPopover = false;
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "MPersonnelAdd",
                    });
                    break;
                case "invit":
                    // 邀请新员工加入
                    this.$router.push({
                        name: "MPersonnelInvite",
                        query: {
                            type: 2,
                        },
                    });
                    break;
                case "batch":
                    // 批量操作
                    this.isCheck = true;
                    break;
            }
        },
        // 展示选中用户
        handleClickShowUser() {
            this.selectUserListVisible = true;
        },
        // 批量操作确认类型
        handleClickOperateType(type) {
            if (!this.selectedList.length) return this.$toast("请至少选择一条数据");
            switch (type) {
                case "changeDepartment":
                    // 变更部门
                    const ids = this.selectedList.map((item) => item.user_id);
                    // localStorage.setItem("MPersonnelDepartmentChangeList", JSON.stringify(ids));
                    this.$router.push({
                        name: "MPersonnelDepartmentChange",
                        query: {
                            user_ids: ids,
                        },
                    });
                    break;
                case "invit":
                    // 邀请完善信息
                    Dialog.confirm({
                        title: "邀请完善信息",
                        message: "邀请后将通知对应人员完善员工档案，可在【后台管理-设置字段】中设置。",
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            const postData = {
                                users: this.selectedList.map((item) => ({ user_id: item.user_id, original_data: {} })),
                            };
                            CreateProfileEdit(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$toast({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.selectedList = [];
                                            this.isCheck = false;
                                        },
                                    });
                                }
                            });
                        })
                        .catch(() => {});
                    break;
            }
        },
        // 每一项的复选框改变
        handleClickChangeSelect(item) {
            if (item.checked) {
                this.selectedList.push(item);
            } else {
                const index = this.selectedList.findIndex((list) => list.id == item.id);
                this.selectedList.splice(index, 1);
            }
            if (this.selectedList.length < this.tableData.length) {
                this.isCheckAll = false;
            } else {
                this.isCheckAll = true;
            }
        },
        // 全选框改变
        handleClickCheckAll() {
            this.isCheckAll = !this.isCheckAll;
            this.tableData.forEach((item) => {
                this.$set(item, "checked", this.isCheckAll);
            });
        },
        // 已选用户数据复选框选中状态
        changeItemSelete(data) {
            if (data.type == "item") {
                // 取消单个选中
                const item = data.data;
                const list = this.tableData.find((list) => list.user_id === item.user_id);
                if (list) {
                    this.$set(list, "checked", false);
                }
            } else {
                // 取消全部的选择
                this.tableData.forEach((item) => {
                    this.$set(item, "checked", false);
                });
            }
        },
        // 跳转员工详情
        handleClickDetail(row) {
            this.setLocalStorageFunction();
            if (row.quit_info && row.quit_info.quit_status == 0) {
                // 待离职
                this.$router.push({
                    name: "MLeaveOfficeDetail",
                    query: {
                        uid: row.user_id,
                        id: row.quit_info.id,
                    },
                });
            } else {
                this.$router.push({
                    name: "MPersonnelDetail",
                    query: {
                        uid: row.user_id,
                        profile_edit: row.profile_edit && row.profile_edit.uid ? true : false,
                    },
                });
            }
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.$store.dispatch("searchPopupShow", false);
            this.onPullRefreshList();
        },
        onPullRefreshList() {
            this.loading = true;
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            const params = {
                keyword: this.searchForm.keyword,
                department_id: this.searchForm.department_id,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                custom_filter: this.custom_filter,
            };
            getUserListPage(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.tableData = this.tableData.concat(data);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                } else {
                    this.loading = false;
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
            });
        },
        getStaus(i) {
            let status = "";
            switch (i) {
                case 0:
                    status = "";
                    break;
                case 1:
                    status = "pendingEmployment";
                    break;
                case 2:
                    status = "pendingConfirm";
                    break;
                case 3:
                    status = "pendingLeave";
                    break;
                case 4:
                    status = "unRegist";
                    break;
            }
            return status;
        },
    },
};
</script>

<style lang="scss" scoped>
.personnel_list_wrap {
    .top_search {
        padding: 6px 16px;
        background: rgba(255, 255, 255, 1);

        .van-search {
            padding: 0;
            border-radius: 6px;
            background-color: rgba(243, 243, 243, 1);
            overflow: hidden;

            .van-search__content {
                background-color: rgba(243, 243, 243, 1);

                ::v-deep {
                    .van-icon-search {
                        color: rgba(51, 51, 51, 1);
                    }
                }
            }
        }
    }
    .list_content_title {
        height: 45px;
        background: rgba(255, 255, 255, 1);
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid rgb(247, 248, 250);
        & > span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }
        .list_content_title_right {
            display: flex;
            gap: 8px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
            .custom_checkbox {
                display: block;
                width: 16px;
                height: 16px;
                opacity: 1;
                border-radius: 2px;
                border: 1px solid rgba(153, 153, 153, 1);
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 8px;
                    height: 8px;
                    opacity: 1;
                    border-radius: 1px;
                    border: 1px solid rgba(153, 153, 153, 1);
                }
                &.active {
                    border-color: rgba(41, 144, 255, 1);
                    &::after {
                        background-color: rgba(41, 144, 255, 1);
                        border-color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
    }
    .mobile_container {
        ul {
            li {
                padding: 0 16px;
                height: 68px;
                margin-bottom: 1px;
                background-color: rgba(255, 255, 255, 1);
                display: flex;
                align-items: center;
                gap: 8px;
                .img_box {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    background-color: rgba(204, 204, 204, 1);
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                }
                .list_item_middle {
                    flex: 1;
                    overflow: hidden;
                    p:nth-child(1) {
                        font-size: 14px;
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                        margin-bottom: 2px;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    .tag_status {
                        flex-shrink: 0;
                        height: 18px;
                        padding: 0 4px;
                        border-radius: 5px;
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 18px;
                        &.tag_status_warning {
                            background-color: rgba(240, 170, 50, 0.15);
                            color: rgba(240, 170, 50, 1);
                        }
                        &.tag_status_success {
                            background-color: rgba(90, 179, 51, 0.15);
                            color: rgba(90, 179, 51, 1);
                        }
                        &.tag_status_danger {
                            background-color: rgba(228, 65, 68, 0.15);
                            color: rgba(228, 65, 68, 1);
                        }
                        &.tag_status_primary {
                            background-color: rgba(41, 144, 240, 0.15);
                            color: rgba(41, 144, 240, 1);
                        }
                        &.tag_status_warning2 {
                            background-color: rgba(255, 141, 26, 0.15);
                            color: rgba(255, 141, 26, 1);
                        }
                    }
                    p:nth-child(2) {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(102, 102, 102, 1);
                    }
                }
                .list_item_right {
                    height: 100%;
                    padding-left: 16px;
                    display: flex;
                    align-items: center;

                    ::v-deep {
                        .van-checkbox__icon {
                            font-size: 16px;

                            .van-icon {
                                border-color: rgba(217, 217, 217, 1);
                                border-radius: 4px;
                                background-color: rgba(255, 255, 255, 1);
                            }
                        }

                        .van-checkbox__icon--checked {
                            .van-icon {
                                border-color: rgba(41, 144, 255, 1);
                                background-color: rgba(41, 144, 255, 1);
                            }
                        }
                    }
                }
            }
        }
    }
}
.batch_select_icon {
    position: absolute;
    bottom: 107px;
    right: 16px;
    width: 30px;
    height: 30px;
    background: rgba(75, 162, 255, 1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
        font-size: 20px;
        color: #ffffff;
    }

    span {
        position: absolute;
        top: -1px;
        right: 0;
        padding: 0 3px;
        font-size: 8px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 12px;
        color: rgba(255, 255, 255, 1);
        background: rgba(228, 65, 68, 1);
        border-radius: 50%;
    }
}
</style>
<style lang="scss">
.top_operator_list {
    width: 104px;
    padding: 4px 0;
    li {
        list-style: none;
        width: 100%;
        height: 38px;
        line-height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
        }
        &:active {
            background-color: rgba(153, 153, 153, 0.04);
        }
    }
}
</style>
